import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import DemoRegisterList from "./DemoRegisterList";
import Login from "./Login";

function App() {
  return (
    <HashRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<DemoRegisterList />} />
          <Route path="/login" element={<Login />} />
          {/* Default fallback route */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
